import type { EventDefinition, ParamsType } from "../types";

// Referral page events
export const referralEventDefinitions: EventDefinition[] = [
  {
    name: "nextCoverageClicked",
    type: "structured",
    makePayload: params => {
      const { url } = params as ParamsType;
      const eventName = "post_referral_workers_compensation_continuation_link";

      return {
        category: eventName,
        action: "link_click",
        label: eventName,
        property: url,
      };
    },
  },
];
